<template>
  <div v-if="list.length">
    <div class="lesson-header">
      <div class="lesson-header-left">
        <ym-img class="icon" :src="require('@/assets/img/course/title_lesson.png')" />
        <span>课程目录</span>
      </div>
      <div class="lesson-header-right" @click="changeSort">
        <ym-icon class="icon" name="mr-sort" />
        {{ sortText }}
      </div>
    </div>
    <div class="lesson-list lesson">
      <div v-for="(item, index) in lessonList" :key="index" class="lesson-list-item" @click="handleClickItem">
        <div class="lesson-list-item-top">第{{ item.seq }}课 | {{ item.title }}</div>
        <div class="lesson-list-item-bottom">
          <div class="lesson-list-item-bottom-left">
            <template v-if="item.status === 'living'">
              <ym-img class="lesson-list-item-bottom-left-icon live"
                :src="require('@/assets/img/course/lesson_live.png')" />
              <div class="lesson-list-item-bottom-left-text live">直播中</div>
            </template>

            <template v-else-if="item.status === 'liveEnd'">
              <ym-img class="lesson-list-item-bottom-left-icon"
                :src="require('@/assets/img/course/lesson_duration.png')" />
              <div class="lesson-list-item-bottom-left-text">已结束</div>
            </template>

            <template v-else>
              <div class="lesson-list-item-bottom-left-tag">周{{ item.showStartTime | formatTime('a') }}</div>
              <div class="lesson-list-item-bottom-left-text">{{ item.showStartTime | formatTime('MM月dd日 HH:ii') }}</div>
            </template>
          </div>
          <ym-icon v-if="!member" name="mr-lock" size="28" color="#ccc" />
          <div v-else-if="item.status === 'liveEnd'" class="lesson-list-item-bottom-right btn1">回放生成中</div>
          <div v-else-if="item.status === 'willBeLive'" class="lesson-list-item-bottom-right btn1">即将开始</div>

          <div v-else-if="item.status === 'hasReplay'" class="lesson-list-item-bottom-right btn3"
            @click.stop="enterClassroom(item)">回放</div>

          <div v-else-if="item.status === 'living'" class="lesson-list-item-bottom-right btn2"
            @click.stop="enterClassroom(item)">进入教室</div>
        </div>
      </div>
    </div>
  </div>
  <!--  <div v-else-->
  <!--       class="empty"-->
  <!--  >-->
  <!--    直播课时尚未更新，请留意简介-->
  <!--  </div>-->
</template>

<script>
import { getCourseLessonPLayUrl } from '@/services/course';
import { getProductPath, locationHref, projectJump } from '@/utils';
import joinProductMixin from '@/mixins/order/joinProduct';
import { informMe } from '@/services/app';
import validator from '@/utils/validator';

export default {
  name: 'CourseDetailLiveList',
  mixins: [joinProductMixin],
  props: {
    list: Array,
    member: Boolean,
    product: Object,
    sell: {
      type: Object,
      required: true,
    },
    actionBtn: {
      validator(val) {
        return validator.isObject(val);
      },
    },
  },
  data() {
    return {
      lessonList: [],
      sortText: '正序',
    };
  },
  watch: {
    list: {
      handler(val) {
        if (val) this.lessonList = val;
      },
      immediate: true,
    },
  },
  methods: {
    changeSort() {
      this.lessonList.reverse();
      this.sortText = this.sortText === '正序' ? '倒序' : '正序';
    },
    async enterClassroom(info) {
      const stp = info.showStartTime; // 目标的时间戳
      const now = new Date().getTime(); // 当前时间的时间戳
      // 计算时间差值，单位为毫秒
      const timeDiff = now - (stp * 1000);
      // 将时间差值转换为天数
      const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      // 判断是否超过730天
      if (daysDiff > 730) {
        this.$toast('超过2年以上直播课程不能回放');
        return;
      }

      if (this.member) {
        const data = await getCourseLessonPLayUrl(this.product.id, info.id);
        if (data.action === 'location') {
          locationHref(data.originUrl);
          return;
        }
        this.$router.push({
          name: 'ClassRoomDetail',
          query: { courseId: this.product.id, lessonId:info.id },
        });
        return;
      }
      this.$toast('您尚未加入课程');
    },

    async handleInformMe() {
      await informMe(this.product.id, this.product.type);
    },
    showNextProduct() {
      const { sell } = this;
      const { nextProductId } = sell;
      if (nextProductId && nextProductId > 0) {
        const { type } = this.product;
        const route = getProductPath(type, nextProductId);
        projectJump(route);
      }
    },
    handleClickItem() {
      if (this.member) return;
      const { sell } = this;
      const { status } = sell;
      switch (status) {
        case 'unstart':
          this.$toast('尚未开售，敬请期待');
          break;
        case 'informMe':
          this.$dialog.confirm({
            title: '提示',
            message: '本期课程已售罄，下期开售通知我',
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            closeOnClickOverlay: false,
          }).then(() => {
            this.handleInformMe();
          }).catch();
          break;
        case 'goToNextProduct':
          this.$dialog.confirm({
            title: '提示',
            message: '本期已售罄，新一期火热招生中，赶紧去报名吧',
            confirmButtonText: '去报名',
            cancelButtonText: '取消',
            closeOnClickOverlay: false,
          }).then(() => {
            this.showNextProduct();
          }).catch();
          break;
        default:
          this.$dialog.confirm({
            title: '提示',
            message: '加入课程来解锁吧',
            confirmButtonText: '立即购买',
            cancelButtonText: '取消',
            closeOnClickOverlay: false,
          }).then(() => {
            this.handleAction();
          }).catch();
          break;
      }
    },
    async handleAction() {
      await this.mixinHandleClickJoinBtn(this.actionBtn, 'joinProduct');
    },
  },
  created() { },
};
</script>

<style scoped lang="less">
@import "~@/assets/styles/var.less";

.lesson {
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 32px;
    padding-right: 40px;
    height: 122px;

    &-left {
      display: flex;
      align-items: center;

      .icon {
        width: 33px;
        height: 22px;
        margin-right: 6px;
      }

      span {
        color: #222;
        font-size: 32px;
        font-weight: bold;
      }
    }

    &-right {
      width: 104px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f5f6f7;
      color: @color-text-lighter;
      font-size: @font-size-small;
      border-radius: 13px;
      cursor: pointer;
    }
  }

  &-list {
    padding: 0 32px;

    .lesson-list-item {
      width: 686px;
      border-radius: 15px;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.08);
      display: flex;
      flex-direction: column;
      padding: 40px 30px 30px;
      box-sizing: border-box;
      margin-bottom: 40px;

      &-top {
        color: #222;
        font-size: 32px;
        font-weight: bold;
        margin-bottom: 30px;
      }

      &-bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &-left {
          display: flex;
          align-items: center;

          &-tag {
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            border: 1px solid #999;
            padding: 0 11px;
            color: #999;
            font-size: 24px;
            margin-right: 16px;
          }

          &-icon {
            width: 28px;
            height: 28px;
            margin-right: 10px;

            &.live {
              width: 51px;
            }
          }

          &-text {
            color: #999;
            font-size: 28px;

            &.live {
              color: #ff8500;
            }
          }
        }

        &-right {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 60px;
          padding: 0 30px;
          border-radius: 15px;
          font-size: 28px;

          &.btn1 {
            background: #f5f6f7;
            color: #666;
          }

          &.btn2 {
            background: #02cccc;
            color: #fff;
          }

          &.btn3 {
            border: 1px solid #ccc;
            color: #666;
          }
        }
      }
    }
  }
}
</style>
